import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

export const BASE_GRAPHQL_ENDPOINT = "https://api.analytics-dev.imfeature.com/graphql/";

const httpLink = createHttpLink({
	uri: BASE_GRAPHQL_ENDPOINT,
});

export const TOKEN = localStorage.getItem("token");

const authLink = setContext((_, { headers }) => {
	return {
		headers: {
			...headers,
			authorization: `Bearer ${TOKEN}`
		}
	};
});

export const client = new ApolloClient({
	cache: new InMemoryCache(),
	link: authLink.concat(httpLink)
});